<template>
    <div class="main">
      <span class="main-config">
        <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
          <label>{{ $t('operacoes') }} </label>
          <b-form-select
            class="input-pentagro"
            v-model="operationSelected"
            :options="operations"
          ></b-form-select>
        </div>
        <b-form v-if="operationSelected" class="b-layout">
          <b-card v-if="equipments.length > 0">
            <div v-for="(prop, index) in equipments" :key="prop.caption + index">
              <b-form-checkbox
                class="switch-item"
                v-model="prop.value"
                @change="ChangeOnOff($event, prop)"
                switch
                >
                {{ prop.equipName }}
              </b-form-checkbox>
            </div>
          </b-card>
          <b-card v-else class="card-equip">
            <div>{{ $t('operacao-sem-equipamentos') }}</div>
          </b-card>
            <b-card class="card-equip" >
              <div class="inp" v-if="area">
                <label>{{ $t('area-m-0') }}</label>
                <label>{{ area.value | ParseNumber }}</label>
              </div>
              <div class="inp" v-if="T4">
                <label>{{ $t('temperatura-oc') }}</label>
                <b-input class="input-pentagro" v-model="T4.value" />
              </div>
              <div class="inp" v-if="TaxaOcupacao">
                <label>{{ $t('ocupacao-1') }} </label>
                <label>{{ TaxaOcupacao.value | ParseNumber }}</label>
              </div>
            </b-card>
        </b-form>
      </span>
      <div v-if="jokerEquipmentList.length" class="joker">
        <label class="mt-2">{{ $t('equipamentos-coringas') }}</label>
        <div v-for="(joker, i) in jokerEquipmentList" :key="i">
          <b-form>
            <div class="ml-2 mr-2">
              <span v-if="readOnly">
                <label>{{ joker.caption }}</label>
              </span>
              <span v-else>
                <TextToInput
                  :text="joker.caption"
                  @sendText="updateCaption($event, joker)"
                >
                </TextToInput>
              </span>
            </div>
            <span class="b-layout">
              <b-card v-if="equipments.length > 0">
                <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                  <b-form-checkbox
                    class="switch-item"
                    v-model="prop.value"
                    @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                    switch
                    >
                    {{ prop.equipName }}
                  </b-form-checkbox>
                </div>
              </b-card>
              <div class="ml-3" v-if="equipments.length > 0">
                <b-card>
                  <div class="inp">
                    <label>{{ $t('area-m-0') }}</label>
                    <label>{{ joker.capacidade.value | ParseNumber }}</label>
                  </div>
                  <div class="inp">
                    <label>{{ $t('ocupacao-0') }}</label>
                    <label>{{ joker.Ocupacao.value | ParseNumber }}</label>
                  </div>
                </b-card>
              </div>
            </span>
          </b-form>
        </div>
      </div>
    </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from "../../../mixins/jokerEquipmentsMixin";
import TextToInput from "../../../template/TextToInput.vue";
import { FiltersMixin }  from '../../../mixins/filtersMixin'

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  components: { TextToInput },

  mixins: [ JokerEquipmentMixin, FiltersMixin ],


  data() {
    return {
      attrList: ["area", "TaxaOcupacao", "T4"],
      area: {},
      TaxaOcupacao: {},
      T4: {},
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      if (this.equipments.length > 0) {
        this.area = this.operationAttributeList.find(
          (p) => this.attrList[0] == p.caption
        );
      }

      this.area = this.operationAttributeList.find(
        (p) => this.attrList[0] == p.caption
      );

      this.TaxaOcupacao = this.operationAttributeList.find(
        (p) => this.attrList[1] == p.caption
      );

      this.T4 = this.operationAttributeList.find(
        (p) => this.attrList[2] == p.key
      );

      this.jokerEquipmentList = [];
      this.updateNode();
    },

    "area.value"() {
      this.updateNode();
    },

    "T4.value"() {
      this.updateNode();
    },

    "TaxaOcupacao.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data.length > 0) {
        if (this.node.data[0].index) {
          this.buildJokerEquipment(
            this.node.data[0].index,
            this.node.jokerCaption
          );
          this.firstLoad = true;
          this.operationSelected = this.node.data[0].index;
          this.loadNotInput();
        }
      }

      
      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (p.equipName) {
          let equip = p.clone();
          equip.value = parseInt(equip.value) ? true : false;
          
          this.equipments.push(equip);
        }
        
        if (p.key == "T4") {
          p.value = ParseToNumber(p.value);
          this.T4 = p;
        }
        
        if (p.key == "area") {
          p.value = ParseToNumber(p.value);
          this.area = p;
        }
        
        if (p.key == "TaxaOcupacao") {
          p.value = ParseToNumber(p.value);
          this.TaxaOcupacao = p;
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    updateCaption(caption, joker) {
      joker.caption = caption;
      this.updateNode();
    },

    updateNode() {
      let attrs = [];

      if(this.T4.value)
        attrs.push(this.T4.clone())

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });
      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );

      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.switchStatusJoker(
        prop,
        this.equipments,
        false,
        this.ChangeCapacidade
      );
      this.updateNode();
    },

    ChangeCapacidade() {
      if (this.area) {
        this.area.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap)
            this.area.value += parseFloat(String(cap.value).replace(",", "."));
        });
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/EC_/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.changeExternalCapacity = function () {
      this.ChangeCapacidade();
    };
    this.updataNodeInMixin = function () {
      this.updateNode();
    };
  },
};
</script>

<style scoped>
.main {
  display: flex;
}

.card-equip {
  display: table;
  height: 100%;
  width: 48%;
}
.card-equip > div{
  display: table-cell;
  vertical-align: middle;
  font-size: 0.85rem;
}

.form-control {
  width: 32%;
  height: 30px;
  text-align: right;
}

input {
  margin-left: 5px;
}

.main-config,
.joker {
  width: 500px;
  height: 25vh;
  overflow-y: auto;
}
.width-155 {
  width: 155px;
}

.input-data {
  width: 70px;
  text-align: right;
}

form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 80px);
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>